
/**
 * Data Simulation Utility
 * Used to generate mock data with high fluctuation for demonstration purposes.
 */

// Generate random fluctuating data
export function generateFluctuatingData(days = 7, baseValue = 100, variance = 0.5) {
  const data = [];
  const end = new Date();
  
  // Create data for past N days
  for (let i = days - 1; i >= 0; i--) {
    const d = new Date();
    d.setDate(end.getDate() - i);
    const dateStr = d.toISOString().split('T')[0];
    
    // Random value with high variance
    // Random factor between 1-variance and 1+variance
    const randomFactor = 1 + (Math.random() * 2 - 1) * variance;
    
    // Add some trend (optional, e.g., slight growth)
    // const trend = 1 + (days - i) * 0.01; 
    
    let val = baseValue * randomFactor;
    val = Math.max(0, val); // No negative values
    
    data.push({
      date: dateStr,
      value: Math.floor(val)
    });
  }
  return data;
}

// Mock Overview Stats Response
export const mockOverviewStats = (params = {}) => {
  const range = params.range || 7;
  
  // High variance (0.8 = 80% fluctuation)
  return Promise.resolve({
    code: 0,
    message: 'success',
    data: {
      deliver_weight: generateFluctuatingData(range, 500, 0.8), 
      deliver_times: generateFluctuatingData(range, 50, 0.7),
      cleaning_weight: generateFluctuatingData(range, 400, 0.9),
      cleaning_times: generateFluctuatingData(range, 20, 0.6)
    }
  });
}

// Mock Rankings Response
export const mockRankingsStats = () => {
  // Generate random rankings
  const names = ['张三', '李四', '王五', '赵六', '孙七', '周八', '吴九', '郑十'];
  
  const generateRank = (base) => {
    return names.map(name => ({
      name: name,
      value: Math.floor(base * (0.5 + Math.random()))
    })).sort((a, b) => b.value - a.value);
  };

  return Promise.resolve({
    code: 0,
    message: 'success',
    data: {
      user_deliver_weight: generateRank(100),
      user_deliver_times: generateRank(20),
      device_recycle_weight: generateRank(500),
      device_cleaning_weight: generateRank(400)
    }
  });
}
